import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_LUNAR_THEME_API_ENDPOINT,
  params: {
    code: process.env.REACT_APP_LUNAR_THEME_API_CODE,
    clientId: "lunar-frontend",
  },
});
